module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"siteTitle":"Company Settings"},"de":{"siteTitle":"Unternehmenseinstellungen"},"fr":{"siteTitle":"Paramètres d\u0027enterprise"},"it":{"siteTitle":"Impostazioni aziendali"}}')
  delete Component.options._Ctor
}
